import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  TuiDataListModule,
  TuiHintModule,
  TuiTextfieldControllerModule
} from "@taiga-ui/core";
import {
  TuiComboBoxModule,
  TuiDataListWrapperModule,
  TuiFilterByInputPipeModule,
  TuiSelectModule
} from "@taiga-ui/kit";
import { KwikUIInputSelectComponent } from "./input-select.component";

@NgModule({
  declarations: [KwikUIInputSelectComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiComboBoxModule,
    TuiDataListModule,
    TuiDataListWrapperModule,
    TuiFilterByInputPipeModule,
    TuiHintModule,
    TuiSelectModule,
    TuiTextfieldControllerModule
  ],
  exports: [KwikUIInputSelectComponent]
})
export class KwikUIInputSelectModule {}
